const KEY = {
    SCHEDULE_TASK_UPDATE: "schedule.task.update",
    SCHEDULE_TASK_ASSIGN: "schedule.task.assign"
};

export default {
    KEY
};
